module.exports = __webpack_public_path__ + "static/media/sample_cat_salem.93bb8a69.png";